import Icon from '../components/Icon.vue'

Icon.register({
  'puzzle-piece': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M519.4 288.7c37.6 0 56.6 31.6 56.6 65.8 0 33.5-19.3 61.6-54.9 61.6-39.9 0-50.3-36.2-86.3-36.2-60.6 0-25.8 120.1-25.8 120.1-51.6 0-181.2 35.1-181.2-25.7 0-35.8 36.3-46.3 36.3-86 0-35.5-28.1-54.7-61.8-54.7-34.3 0-63.6 18.9-63.6 56.3 0 41.4 40 59 40 81.5 0 69.7-178.6 28.7-178.6 28.7v-333.2s175.9 41 175.9-28.7c0-22.5-31.7-40.4-31.7-81.8 0-37.5 31.7-56.3 66.4-56.3 33.3 0 61.5 19.2 61.5 54.7 0 39.7-36.3 50.2-36.3 86 0 83.3 196.3 3.3 196.3 3.3s-54.6 176.2 5.4 176.2c22.6 0 40.5-31.6 82.1-31.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/puzzle-piece.js
// module id = 1667
// module chunks = 0